import { Button } from 'antd';
import styles from './SideBar.module.less';
import {
	HomeFilled,
	UpOutlined,
	DownOutlined,
	MessageOutlined,
	CalendarOutlined,
	MenuFoldOutlined,
	CarryOutOutlined,
	ContainerOutlined,
	MenuUnfoldOutlined,
	ClockCircleOutlined,
	QuestionCircleOutlined,
} from '@ant-design/icons';
import { useLayoutContext } from '../LayoutContext';
import cn from 'classnames';
import { paths } from 'config';
import { NavLink } from 'react-router-dom';
import goesLogo from 'assets/images/goes.logo.png';
import { I18nt } from 'utils';
import { LangText } from 'utils/interfaces';
import ReservationIcon from 'components/Icons/ReservaIcon';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
interface MenuItem {
	icon: JSX.Element;
	titleShort: LangText;
	title: LangText;
	path: string;
	subMenus?: MenuItem[];
}

const menuItems: MenuItem[] = [
	{
		icon: <HomeFilled />,
		titleShort: 'inicio',
		title: 'inicio',
		path: paths.home,
	},
	{
		icon: <CalendarOutlined />,
		titleShort: 'citas',
		title: 'citas_medicas',
		path: 'citas',
		subMenus: [
			{
				icon: <CarryOutOutlined />,
				titleShort: 'citas',
				title: 'calendarizacion_citas',
				path: paths.agendar_cita,
			},
			{
				icon: <ClockCircleOutlined />,
				titleShort: 'historial',
				title: 'mis_citas',
				path: paths.historial_citas,
			},
		],
	},
	{
		icon: <ReservationIcon />,
		titleShort: 'reserva',
		title: 'reserva_de_medicamento',
		path: paths.consultar_medicamentos,
	},
	{
		icon: <ContainerOutlined />,
		titleShort: 'examenes',
		title: 'examenes_de_laboratorio',
		path: paths.examenes_laboratorio,
	},
];

const subMenuItems: MenuItem[] = [
	{
		icon: <QuestionCircleOutlined />,
		titleShort: 'ayuda',
		title: 'preguntas_frecuentes',
		path: paths.faq,
	},
	{
		icon: <MessageOutlined />,
		titleShort: 'comenta',
		title: 'compartenos_tu_opinion',
		path: paths.contact,
	},
];

function SideBar() {
	const { pathname } = useLocation();
	const { isOpen, setIsOpen, setSubMenu, isSubMenuOpen, subMenuOpen } =
		useLayoutContext();

	const navLinkClass = ({ isActive }: { isActive: boolean }) => {
		return cn({
			[styles.linkActive]: isActive && !isOpen,
			[styles.linkActiveAndOpen]: isActive && isOpen,
		});
	};

	const NavItem = ({ item }: { item: MenuItem }) => {
		return (
			<li>
				<NavLink className={navLinkClass} to={item.path}>
					<span className={styles.icon}>{item.icon}</span>
					<span className={styles.titleShort}>{I18nt(item.titleShort)}</span>
					<span className={styles.title}>{I18nt(item.title)}</span>
				</NavLink>
			</li>
		);
	};

	useEffect(() => {
		if (!isOpen) {
			setSubMenu(undefined);
		}
	}, [isOpen]);

	const subMenuParentClasses = (paths: string[]) => {
		if (!isOpen || subMenuOpen === undefined) {
			const isActive = paths.includes(pathname);
			return navLinkClass({ isActive });
		}
	};

	const nav = (items: MenuItem[]) => {
		return (
			<nav>
				<ul className={cn(styles.navList, { [styles.navListOpen]: isOpen })}>
					{items.map((item) => {
						const { subMenus, path, icon, titleShort, title } = item;

						if (subMenus && subMenus.length) {
							const subMenuPaths = subMenus.map((sm) => sm.path);
							return (
								<li key={path}>
									<a
										href=''
										className={subMenuParentClasses(subMenuPaths)}
										onClick={(event) => {
											event.preventDefault();
											setSubMenu(path);
											setIsOpen(true);
										}}
									>
										<span className={styles.icon}>{icon}</span>
										<span className={styles.titleShort}>
											{I18nt(titleShort)}
										</span>
										<span className={styles.title}>{I18nt(title)}</span>
										{isOpen && (
											<span className={styles.caretContainer}>
												{isSubMenuOpen(path) ? (
													<UpOutlined />
												) : (
													<DownOutlined />
												)}
											</span>
										)}
									</a>

									<ul
										className={cn(styles.subMenu, {
											[styles.subMenuOn]: isSubMenuOpen(path),
											[styles.subMenuOff]: !isSubMenuOpen(path),
											[styles.subMenuOpenMode]: isOpen,
										})}
									>
										{subMenus.map((sm) => (
											<NavItem key={sm.path} item={sm} />
										))}
									</ul>
								</li>
							);
						}
						return <NavItem key={path} item={item} />;
					})}
				</ul>
			</nav>
		);
	};

	return (
		<div
			className={cn(styles.sideBar, {
				[styles.sideBarOpen]: isOpen,
				[styles.sideBarClose]: !isOpen,
			})}
		>
			<img
				src={goesLogo}
				className={cn({ [styles.logo]: !isOpen, [styles.logActive]: isOpen })}
				alt={I18nt('goes_logo_alt')}
			/>
			<div className={styles.buttonWrapper}>
				<Button
					type='text'
					className={styles.menuButton}
					onClick={() => setIsOpen((current) => !current)}
				>
					{isOpen ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
				</Button>
			</div>
			<div
				className={cn(styles.navWrapper, {
					[styles.navWrapperActive]: isOpen,
				})}
			>
				{nav(menuItems)}
				{nav(subMenuItems)}
			</div>
		</div>
	);
}

export default SideBar;
